import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { createAPI } from 'services/api/api';
import Loader from 'components/Loader';
import Pagination from 'components/Pagination';
import PlaceholderBlockProfile from 'components/placeholder-blocks/PlaceholderBlockProfile';
import ProfileTransactionsTable from 'components/profile/ProfileTransactionsTable';

const ProfileTransactions = () => {
  const api = createAPI();
  const { notificationsList } = useSelector((state) => state.user);
  const oldNotificationsList = useRef(notificationsList);
  const { refreshTrigger } = useSelector((state) => state.cards);
  const [isLoading, setIsLoading] = useState(true);
  const [items, setItems] = useState([]);
  const [paginationData, setPaginationData] = useState({});
  const [offsetCount, setOffsetCount] = useState(0);

  const fetchData = () => {
    setIsLoading(true);
    api.get(`/me/transaction?limit=20&offset=${offsetCount}`)
      .then((response) => {
        setItems(response.data.data);
        setPaginationData(response.data.pagination_metadata);
      })
      .catch((error) => {
        console.log('failed to fetch profile transactions', error);
        setItems([]);
      })
      .finally(() => setIsLoading(false));
  };

  useEffect(() => {
    if (oldNotificationsList.current !== notificationsList) {
      oldNotificationsList.current = notificationsList;
      fetchData();
    }
  }, [notificationsList]);

  useEffect(() => {
    fetchData();
  }, [offsetCount, refreshTrigger]);

  if (!items.length && !isLoading) {
    return (
      <main className="profile-content">
        <PlaceholderBlockProfile />
      </main>
    );
  }

  return (
    <main className="profile-content">
      {isLoading ? <Loader />
        :
        <>
          <div className="cards-list">
            <header className="cards-list__header">
              <div className="cards-list__header-info">
                <h2 className="cards-list__title">
                  Transactions
                  <span>{paginationData.total_count}</span>
                </h2>
              </div>
            </header>
            <ProfileTransactionsTable items={items} />
          </div>
          <Pagination offsetCount={offsetCount} setOffsetCount={setOffsetCount} paginationData={paginationData} />
        </>
      }
    </main>
  );
};

export default ProfileTransactions;
